import fetchRequest from './fetch-types/fetch'

// FETCH TYPES WITHOUT AUTH TOKEN IN HEADER
/**
 * Sends a GET request to the specified URL with the provided parameters.
 * This function does not require authentication.
 *
 * @param url - The URL to send the GET request to.
 * @param params - The parameters to include in the request params.
 * @returns A Promise that resolves to the response from the server.
 */
export function getRequestNoAuth<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, false)
}

/**
 * Sends a POST request to the specified URL with the provided parameters.
 * This function does not require authentication.
 *
 * @param url - The URL to send the POST request to.
 * @param params - The parameters to include in the request body.
 * @returns A Promise that resolves to the response from the server.
 */
export function postRequestNoAuth<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, false, 'POST')
}

/**
 * Sends a PATCH request to the specified URL with the provided parameters.
 * This function does not require authentication.
 *
 * @param url - The URL to send the PATCH request to.
 * @param params - The parameters to include in the request body.
 * @returns A Promise that resolves to the response from the server.
 */
export function patchRequestNoAuth<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, false, 'PATCH')
}

// FETCH TYPES WITH AUTH TOKEN IN HEADER

/**
 * Sends a GET request to the specified URL with the provided parameters.
 * This function REQUIRE authentication.
 *
 * @param url - The URL to send the GET request to.
 * @param params - The parameters to include in the request params.
 * @returns A Promise that resolves to the response from the server.
 */
export function getRequest<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, true)
}

/**
 * Sends a POST request to the specified URL with the provided parameters.
 * This function REQUIRE authentication.
 *
 * @param url - The URL to send the POST request to.
 * @param params - The parameters to include in the request body.
 * @returns A Promise that resolves to the response from the server.
 */
export function postRequest<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, true, 'POST')
}

/**
 * Sends a PATCH request to the specified URL with the provided parameters.
 * This function REQUIRE authentication.
 *
 * @param url - The URL to send the PATCH request to.
 * @param params - The parameters to include in the request body.
 * @returns A Promise that resolves to the response from the server.
 */
export function patchRequest<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, true, 'PATCH')
}

/**
 * Sends a DELETE request to the specified URL with the provided parameters.
 * This function REQUIRE authentication.
 *
 * @param url - The URL to send the DELETE request to.
 * @param params - The parameters to include in the request body.
 * @returns A Promise that resolves to the response from the server.
 */
export function deleteRequest<T>(url: string, params: Record<string, unknown>) {
  return fetchRequest<T>(url, params, true, 'DELETE')
}
